import React from "react"
import { func, string } from "prop-types";
import styled from "styled-components"


const Body = styled.div`

	display: flex;
	flex-direction: column;
	margin-bottom:3em;

	/* Tablets */
	@media (max-width: 1400px) {
		margin-bottom: 1em;
	}

	/* Mobiles */
	@media (max-width: 640px) {
		margin-bottom: 1em;
		font-size: 1.1em;
	}

`;

export default Body;